import { PageState } from 'models/PageState';
import { useSelector } from 'react-redux';
import { registry } from 'views/registry';

export default () => {
  const componentName = useSelector<PageState, string>(
    ({ currentPage }) => currentPage.componentName
  );
  const Component = registry(componentName);
  return <Component />;
};
